import React from "react"
import { Sequence, useCurrentFrame, useVideoConfig, Img, Audio, Loop, continueRender, delayRender } from 'remotion';
import { audioBufferToDataUrl } from "@remotion/media-utils";
import { useCallback, useEffect, useState } from "react";
import translations from './MyComp.lang.json';

export const MyComp = ( { listing, user, coAgent, team, brokerage, scope, musicEnabled, song, images, settings, voiceoverEnabled, voiceoverFile, preloadedVoiceoverFile, office, locale } ) => {
    const videoConfig = useVideoConfig();
    const frame = useCurrentFrame();
    const [handle] = useState(() => delayRender());
    const [audioRendered, setAudioRendered] = useState(false);
    const [voiceover, setVoiceover] = useState((''));


    const imageSequences = []
    let count = 0;
    const imgs = images.filter(item => item.show);
    const backgroundColor = settings.find(x => x.setting === "primary_color_web");
    const primaryLogoLight = settings.find(x => x.setting === "primary_logo_light");
    const primaryLogoDark = settings.find(x => x.setting === "primary_logo_dark");

    const t = (key) => {
        if (translations.hasOwnProperty(locale)) {
            return translations[locale][key];
        } else {
            return translations.en[key];
        }
    }

    const formatPhone = (phone) => {
        const phoneStr = `${phone}`;

        if (phoneStr.length === 10) {
            return `${ phoneStr.substring(0, 3) }.${ phoneStr.substring(3, 6) }.${phoneStr.substring(6)}`;
        }

        return phone;
    };

    let mlsid;

    if (listing.manual && listing.mls_id && listing.id !== listing.mls_id) {
        mlsid = listing.mls_id
    } else if (!listing.manual) {
        mlsid = listing.mlsid;
    }

    const brandingHeight = scope.value === 'unbranded' ? 0 : 195;

    // Compute the aggregate bathroom count, including half baths
    let bathCount = 0;

    if (listing.baths) {
        bathCount = listing.baths;
    }

    if (listing.halfbaths) {
        bathCount += (0.5 * listing.halfbaths);
    }

    // eslint-disable-next-line
    imgs.forEach((img) => {
        if(img.show) {

            let opacity = 1
            if(count !== 0) {
                opacity = frame < (img.frameStart + 20) ? (frame - img.frameStart) / 20 : frame <= (img.frameStart + 80) ? 1 : (img.frameStart + 100 - frame) / 20 ;
            } else {
                opacity = frame <= (img.frameStart + 80) ? 1 : (img.frameStart + 100 - frame) / 20 ;
            }

            if(img.intro) {
                let imageCss = {
                    flex: 'none',
                    width: 'auto',
                    display: 'block',
                    opacity,
                    objectFit: 'contain'
                };

                const divCss = {
                    display: 'flex',
                    width: videoConfig.width * .75,
                    overflow: 'hidden'
                };

                const orientation = img.width > img.height ? 'landscape' : 'portrait';
                const aspectRatio = img.width / img.height;
                let done = false;

                const availableSpace = {
                    width: videoConfig.width * 0.75,
                    height: videoConfig.height - brandingHeight
                };

                // for landscape images, attempt to restrict width first
                if (orientation === 'landscape') {
                    imageCss.width = availableSpace.width;
                    const height = availableSpace.width / aspectRatio;

                    // if computed image height with width restricted is at least enough to fill the available space, set height to 'auto' and we're done
                    if (height >= availableSpace.height) {
                        imageCss.height = 'auto';
                        divCss.justifyContent = 'center';
                        done = true;
                    }
                }

                // for portrait, or where width restriction failed, restrict by height
                if (orientation === 'portrait' || !done) {
                    imageCss.height = availableSpace.height;
                    imageCss.width = 'auto';
                    const width = availableSpace.height * aspectRatio;

                    // We only center the image if the height-restricted image is wide enough to fill the space
                    if (width >= availableSpace.width) {
                        divCss.justifyContent = 'center';
                    }
                }

                imageSequences.push(
                    <Sequence from={img.frameStart} durationInFrames={img.duration} key={count}
                        style={{}}
                    >
                        <div style={{
                            backgroundColor: backgroundColor?.value ? backgroundColor.value : '#E46A77',
                            width: videoConfig.width,
                            height: videoConfig.height,
                            opacity
                        }}>
                            <div style={divCss}>
                                <Img src={img.url}
                                    style={imageCss}
                                />
                            </div>
                            <div style={{
                                fontSize: "50px",
                                position: "absolute",
                                top: "215px",
                                right: "100px",
                                display: "flex",
                                flexDirection: "column",
                                opacity,
                                backgroundColor: "#fff",
                                padding: "60px",
                                minWidth: "600px"
                            }}>
                                <div style={{
                                    fontSize: "60px",
                                    fontWeight: "700",
                                    textAlign: "left"
                                }}>
                                    {listing.address}
                                </div>
                                <div style={{
                                    fontSize: "40px",
                                    fontWeight: "400",
                                    textAlign: "left"
                                }}>
                                    {listing.city}, {listing.state} {listing.zip}
                                </div>

                                <div style={{
                                    width: "68px",
                                    height: "6px",
                                    backgroundColor: backgroundColor?.value ? backgroundColor.value : '#E46A77',
                                    margin: "20px 0"
                                }} />
                                { mlsid &&
                                (<div style={{
                                    display: "flex",
                                    fontSize: "32px"
                                }}>
                                    <div>{t('mlsId')} {mlsid}</div>
                                </div>)}
                                <div style={{
                                    display: "flex",
                                    fontSize: "30px",
                                    marginTop: "28px",
                                    justifyContent: "space-between"
                                }}>
                                    <div style={{
                                        display: "flex",
                                        flex: 1,
                                        flexDirection: "row",
                                        alignItems: "center"
                                    }}>
                                        <div style={{marginRight: "6px", flex: 1, textAlign: 'right'}} >
                                            <Img src='../bed.svg'/>
                                        </div>
                                        <div style={{flex: 3, textAlign: 'left'}}>{listing.beds} {t('beds')}</div>
                                    </div>
                                    <div style={{
                                        display: "flex",
                                        flex: 1,
                                        flexDirection: "row",
                                        alignItems: "center"
                                    }}>
                                        <div style={{marginRight: "6px", flex: 1, textAlign: 'right'}} >
                                            <Img src='../bathtub.svg'/>
                                        </div>
                                        <div style={{flex: 3, textAlign: 'left'}}>{bathCount} {t('baths')}</div>
                                    </div>
                                    <div style={{
                                        display: "flex",
                                        flex: 1,
                                        flexDirection: "row",
                                        alignItems: "center"
                                    }}>
                                        <div style={{marginRight: "6px", flex: 1, textAlign: 'right'}} >
                                            <Img src='../sqft.svg'/>
                                        </div>
                                        <div style={{flex: 3, textAlign: 'left'}}>{listing.footage} {t('sqft')}</div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </Sequence>
                )
            } else if(img.outro) {
                imageSequences.push(
                    <Sequence from={img.frameStart} durationInFrames={img.duration} key={count}
                    style={{}}
                    >
                       <div style={{
                            backgroundColor: backgroundColor?.value ? backgroundColor.value : '#E46A77',
                            width: videoConfig.width * .25,
                            height: videoConfig.height,
                            opacity
                        }}>
                        </div>


                        <div style={{
                            backgroundColor: '#F1F1F1',
                            width: videoConfig.width * .75,
                            height: videoConfig.height,
                            opacity
                        }} />
                         <div style={{
                            position: "absolute",
                            top: "215px",
                            left: "100px",
                            display: "flex",
                            flexDirection: "column",
                            opacity,
                            backgroundColor: "#fff",
                            padding: "95px",
                            width: videoConfig.width * .75,
                        }}>
                            <div style={{
                                fontSize: "80px",
                                fontWeight: "700",
                                textAlign: "left"
                            }}>
                                {listing.address}
                            </div>
                            <div style={{
                                fontSize: "55px",
                                fontWeight: "400",
                                textAlign: "left"
                            }}>
                                {listing.city}, {listing.state} {listing.zip}
                            </div>

                            <div style={{
                                width: "68px",
                                height: "6px",
                                backgroundColor: backgroundColor?.value ? backgroundColor.value : '#E46A77',
                                margin: "20px 0"
                            }} />
                            { mlsid &&
                            (<div style={{
                                display: "flex",
                                fontSize: "42px"
                            }}>
                                <div>{t('mlsId')} {mlsid}</div>
                            </div>)}
                            <div style={{
                                display: "flex",
                                fontSize: "40px",
                                marginTop: "28px",
                                justifyContent: "space-between"
                            }}>
                                <div style={{
                                    display: "flex",
                                    width: "33%",
                                }}>
                                    <Img src='../bed.svg' style={{marginRight: "6px"}} />
                                    <div>{listing.beds} {t('beds')}</div>
                                </div>
                                <div style={{
                                    display: "flex",
                                    width: "33%",
                                }}>
                                    <Img src='../bathtub.svg' style={{marginRight: "6px"}} />
                                    <div>{bathCount} {t('baths')}</div>
                                </div>
                                <div style={{
                                    display: "flex",
                                    width: "33%",
                                }}>
                                    <Img src='../sqft.svg' style={{marginRight: "6px"}} />
                                    <div>{listing.footage} {t('sqft')}</div>
                                </div>
                            </div>

                        </div>
                    </Sequence>
                )
            } else {
                const aspectRatio = img.width/img.height;
                let cssWidth, cssHeight, cssTop;

                if (aspectRatio > (16/9)) {
                    // aspect ratio is greater than 16:9
                    cssWidth = `${videoConfig.width}px`;
                    cssHeight = `${videoConfig.width / aspectRatio}px`;
                    cssTop = `${ (videoConfig.height - (videoConfig.width / aspectRatio)) / 2 }px`;
                } else {
                    // aspect ratio is less than or equal to 16:9
                    cssHeight = `${videoConfig.height}px`;
                    cssWidth = `${videoConfig.height * aspectRatio}px`;
                    cssTop = 0;
                }

                imageSequences.push(
                    <Sequence from={img.frameStart} durationInFrames={img.duration} key={count}
                        style={{}}
                    >
                        <Img src={img.url}
                            style={{
                                height: cssHeight,
                                width: cssWidth,
                                position: 'relative',
                                top: cssTop,
                                display: 'block',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                                opacity
                            }}
                        />
                    </Sequence>
                )
            }

            count++
        }
    });

    let agent = ('');
    let coAgentBlock = ('');
    let brokerageBlock = ('');
    let teamBlock = ('');
    let audio = ('');

    if(user && (scope.value === 'coagent' || scope.value === 'agent')) {
        const userHasTitle = user && user.title && user.title !== '';
        const userHasCredentials = user && user.credentials && user.credentials !== '';
        const userHasBoth = userHasTitle && userHasCredentials;

        agent = (

                <div style={{
                    display: "flex",
                    height: "100%",
                    flexDirection: "column",
                    justifyContent: "center"
                }}>
                    <div style={{
                        display: "flex",
                        marginLeft: "32px",
                        alignItems: "center"
                    }}>
                        { user ? <Img src={user.photo} style={{
                            height: `${ brandingHeight - 20 }px`
                        }} /> : ''}
                        <div style={{
                            display: "flex",
                            flexDirection: "column",
                            marginLeft: "16px",
                            textAlign: "left",
                            fontSize: scope.value === 'coagent' ? "24px" : "30px",
                            justifyContent: "space-between"
                        }}>
                            <div>
                                <span style={{
                                    textTransform: "uppercase",
                                    fontWeight: "bold"
                                }}>
                                    { user ? user.full_name : ''}
                                </span>
                            </div>
                            <div>
                                { userHasTitle ? `${user.title}` : '' }
                                { userHasBoth &&
                                    <span>&nbsp;|&nbsp;</span>
                                }
                                { userHasCredentials &&
                                    <span>{t('licNumber')}&nbsp;{ user.credentials }</span>
                                }
                            </div>
                            <div>{ user ? formatPhone(user.cell_phone) : ''}</div>
                            <div>{ user ? user.email : ''}</div>
                        </div>
                    </div>
                </div>
        );
    }

    if(coAgent && scope.value === 'coagent') {
        const coAgentHasTitle = coAgent && coAgent.title && coAgent.title !== '';
        const coAgentHasCredentials = coAgent && coAgent.credentials && coAgent.credentials !== '';
        const coAgentHasBoth = coAgentHasTitle && coAgentHasCredentials;

        coAgentBlock = (

            <div style={{
                display: "flex",
                height: "100%",
                flexDirection: "column",
                justifyContent: "center"
            }}>
                <div style={{
                    display: "flex",
                    marginLeft: "32px",
                    alignItems: "center"
                }}>
                    { coAgent ? <Img src={coAgent.photo} style={{
                        height: `${ brandingHeight - 20 }px`
                    }} /> : ''}
                    <div style={{
                        display: "flex",
                        flexDirection: "column",
                        marginLeft: "16px",
                        textAlign: "left",
                        fontSize: scope.value === 'coagent' ? "24px" : "30px",
                        justifyContent: "space-between"
                    }}>
                        <div>
                            <span style={{
                                textTransform: "uppercase",
                                fontWeight: "bold"
                            }}>
                                { coAgent ? coAgent.full_name : ''}
                            </span>
                        </div>
                        <div>
                            { coAgentHasTitle ? `${coAgent.title}` : '' }
                            { coAgentHasBoth &&
                                <span>&nbsp;|&nbsp;</span>
                            }
                            { coAgentHasCredentials &&
                                <span>{t('licNumber')}&nbsp;{ coAgent.credentials }</span>
                            }
                        </div>
                        <div>{ coAgent ? formatPhone(coAgent.cell_phone) : ''}</div>
                        <div>{ coAgent ? coAgent.email : ''}</div>
                    </div>
                </div>
            </div>
        );
    }

    if(team && scope.value === 'team' ) {
        let email = (team && team.email.length > 0) ? team.email : null;
        let website = null;

        if (team && team.website_url.length) {
            website = team.website_url;
        } else if (team && team.website?.data?.domain) {
            website = team.website.data.domain;
        }

        teamBlock = (

                <div style={{
                    display: "flex",
                    height: "100%",
                    flexDirection: "column",
                    justifyContent: "center"
                }}>
                    <div style={{
                        display: "flex",
                        marginLeft: "32px",
                        alignItems: "center"
                    }}>
                        { team ? <Img src={team.photo} style={{
                            height: `${ brandingHeight - 50 }px`
                        }} /> : ''}
                        <div style={{
                            display: "flex",
                            flexDirection: "column",
                            marginLeft: "16px",
                            textAlign: "left",
                            fontSize: (website && email) ? "24px" : "30px",
                            justifyContent: "center"
                        }}>
                            <div>{ team ? team.name : ''}</div>
                            { email && <div>{ email }</div> }
                            { website && <div>{ website }</div> }
                            <div>{ team ? formatPhone(team.phone) : ''}</div>
                        </div>
                    </div>
                </div>
        );
    }

    if(brokerage || primaryLogoLight?.value || primaryLogoDark?.value) {

        let photo;

        if (primaryLogoLight?.value) {
            photo = primaryLogoLight.value;
        } else if(primaryLogoDark?.value) {
            photo = primaryLogoDark.value;
        } else {
            photo = brokerage.business_photo;
        }

        if (photo) {
            const officeName = office?.name.length > 0
                ? office.name.replaceAll(' ', '&nbsp;')
                : '';

            brokerageBlock = (
                <div style={{
                    height: "100%",
                    marginRight: "24px",
                    textAlign: "center"
                }}>
                    <Img src={photo} style={{
                        height: `${ brandingHeight - 30 }px`,
                        margin: "0 auto"
                    }}/>
                    { (scope.value !== 'brokerage' && (office?.name.length > 0 || office?.phone)) &&
                        <div style={{ fontSize: '25px' }}>
                            <span dangerouslySetInnerHTML={{ __html: officeName }}></span>
                            { (office?.name.length > 0 && office?.phone) &&
                                <span>&nbsp;|&nbsp;</span>
                            }
                            { office?.phone ? formatPhone(office.phone) : '' }
                        </div>
                    }
                </div>
            )
        }
    }

    if(musicEnabled && song?.file) {
        audio = (
            <Loop durationInFrames={song.duration * 30}>
                <Audio src={song.file} volume={(voiceoverEnabled && voiceoverFile) ? 0.3 : 1 } />
            </Loop>)
    }

    const renderAudioBuffer = useCallback(async (enabled, file) => {
        if(enabled && file) {
            const arrayBuffer = await file.arrayBuffer();
            const audioContext = new AudioContext();
            const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);
            const url = audioBufferToDataUrl(audioBuffer);
            setVoiceover((<Audio src={url} />))
        } else {
            setVoiceover(null);
        }
        continueRender(handle);
    }, [handle]);


    useEffect(() => {
        if (preloadedVoiceoverFile) {
            setVoiceover((<Audio src={preloadedVoiceoverFile.url} />));
        } else if(voiceoverEnabled !== null && voiceoverFile !== null && !audioRendered) {
            renderAudioBuffer(voiceoverEnabled, voiceoverFile);
            setAudioRendered(true);
        }
    }, [voiceoverEnabled, voiceoverFile, preloadedVoiceoverFile, audioRendered, renderAudioBuffer]);

    return (
        <div style={{flex: 1}}>
            <div
                style={{
                    height: videoConfig.height,
                    backgroundColor: 'white'
                }}
            >
                {imageSequences}
                { scope.value !== 'unbranded' &&
                <div style={{
                    position: "absolute",
                    width: "100%",
                    height: `${ brandingHeight }px`,
                    backgroundColor: "#ffffff",
                    bottom: "0%",
                    zIndex: 1000,
                    display: "flex",
                    justifyContent: "space-between"
                }}>
                    <div style={{
                        display: "flex"
                    }}>
                        {agent}
                        {coAgentBlock}
                        {teamBlock}
                    </div>
                    <div style={{ textAlign: "center" }}>
                        {brokerageBlock}
                    </div>
                </div>}
            </div>
            {audio}
            {voiceoverEnabled && (voiceoverFile || preloadedVoiceoverFile) && voiceover}
        </div>
    );
};
